import * as React from 'react';
import { observer } from 'mobx-react';
import { centerJustified, flex1, vertical } from 'csstips';
import { em, px } from 'csx';
import { colorWhite } from '../theme/color';
import { style } from 'typestyle';
import { TextScrolling } from './text-scrolling';
import { mediaTablet, mediaMobileOnly } from '../theme/media';
import { ArtistLinkList } from './artist-link-list';
import { resetAnchorStyles } from '../theme/reset';
import {ArtistSchema, TrackSchema} from '../types/schema';
import {AnalyticsController} from "../modules/analytics/controller";

export interface PlayerBarNowPlayingModel {
  track: TrackSchema;
}

export interface PlayerBarNowPlayingProps {
  model: PlayerBarNowPlayingModel;
  onClickLink(event: React.MouseEvent<any>): void;
  i18n?: {
    nowPlaying: string;
    waiting: string;
  };
  analytics: AnalyticsController;
}

@observer
export class PlayerBarNowPlaying extends React.Component<PlayerBarNowPlayingProps, any> {
  render() {
    const { model, onClickLink, i18n = PlayerBarNowPlaying.i18n, analytics } = this.props;

    return (
      <div className={PlayerBarNowPlaying.styles.container}>
        {model.track && (
          <TextScrolling>
            <div>
              <a
                href={`/music/artists/${model.track.artists[0].slug}/track/${model.track.slug}`}
                onClick={this.handleTrackClick.bind(this)}
                className={PlayerBarNowPlaying.styles.trackLink}
                children={model.track.title}
              />
            </div>
            <ArtistLinkList
              analytics={analytics}
              model={model.track}
              onClickLink={onClickLink}
              linkClassName={PlayerBarNowPlaying.styles.artistLink}
            />
          </TextScrolling>
        )}
      </div>
    )
  }

  handleTrackClick = (event: React.MouseEvent<any>) => {
    this.props.analytics.sendMixpanel("User clicks track link", {
      "title": this.props.model.track.title,
      "slug": this.props.model.track.slug
    });

    this.props.onClickLink(event)
  }

  static i18n = {
    nowPlaying: 'Now playing',
    waiting: 'Waiting...'
  }

  static styles = {
    container: style(
      {
        ...vertical,
        ...centerJustified,
        lineHeight: em(1.1),
        padding: '0 16px',
        marginTop: px(5),
        color: colorWhite.toString()
      },
      mediaTablet({
        width: px(160)
      }),
      mediaMobileOnly({
        ...flex1,
        minWidth: px(70),
        padding: '0 0 0 16px',
      })
    ),
    nowPlaying: style({
      fontSize: px(12)
    }),
    trackLink: style({
      fontWeight: 600,
      fontSize: px(15),
      lineHeight: em(1.1),
      color: colorWhite.toString(),
      $nest: {
        ...resetAnchorStyles()
      }
    }),
    artistLink: style({
      fontSize: px(12),
      lineHeight: em(1.1),
      color: colorWhite.toString(),
      $nest: {
        ...resetAnchorStyles()
      }
    })
  }
}